<template>
  <div class="flex border-l-4 border-purplish w-full bg-light-blue text-secondary-text pt-2 pb-3">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
